import { isDevelopment } from 'env-utils';
import { FC, useEffect } from 'react';
import { useSnapshot } from 'valtio';
import AppSpinner from '../../common/components/AppSpinner';
import { loadApiKeys } from '../actions/api-keys-actions';
import ApiKeysLoadError from '../components/ApiKeysLoadError';
import ApiKeysTable from '../components/ApiKeysTable';
import ApiKeysStore from '../stores/api-keys-store';
import { ApiKeyRoleType } from '../types/api-key-types';
import CreateApiKeyContainer from './CreateApiKeyContainer';
import DeleteApiKeyContainer from './DeleteApiKeyContainer';
import SetApiKeyExpirationContainer from './SetApiKeyExpirationContainer';
import SetApiKeyStatusContainer from './SetApiKeyStatusContainer';

const ApiKeySettingsContainer: FC<
  React.PropsWithChildren<ApiKeySettingsContainerProps>
> = props => {
  const { isUserAdminRole } = props;
  const { apiKeys, isLoading, errorMessage } = useSnapshot(ApiKeysStore);
  const apiKeyRoleTypes = isDevelopment()
    ? [ApiKeyRoleType.CICDIntegration, ApiKeyRoleType.APIIntegration]
    : [ApiKeyRoleType.CICDIntegration];

  useEffect(() => {
    if (apiKeys.length === 0 && !errorMessage) {
      loadApiKeys();
    }
  }, [apiKeys.length, errorMessage]);

  if (isLoading) {
    return <AppSpinner text='Loading API Key settings' />;
  }

  if (errorMessage) {
    return <ApiKeysLoadError errorMessage={errorMessage} />;
  }

  return (
    <>
      <CreateApiKeyContainer apiKeyRoleTypes={apiKeyRoleTypes} />
      <DeleteApiKeyContainer />
      <SetApiKeyStatusContainer />
      <SetApiKeyExpirationContainer />
      <ApiKeysTable apiKeys={apiKeys} isUserAdminRole={isUserAdminRole} />
    </>
  );
};

export interface ApiKeySettingsContainerProps {
  isUserAdminRole: boolean;
}

export default ApiKeySettingsContainer;
